import { lightenDarkenColor } from "@cd2/tools/build/es6"
import React, { useContext } from "react"
import { IRecordWithoutId } from "../types/schema"
import { ThemeProvider } from "./ThemeProvider"
import { useGlobalState } from "../utils/globalState"

type ICompany = IRecordWithoutId<
  "companies",
  "name" | "imageFileboyId" | "primaryColor" | "secondaryColor" | "logoIsPartnership"
>

type IContextValue = { company: ICompany }

export const CompanyThemeContext = React.createContext<IContextValue | null>(null)

export function useCompanyTheme() {
  const value = useContext(CompanyThemeContext)
  return value?.company
}

export function CompanyThemeLoader(props: { children: React.ReactNode }) {
  const globalState = useGlobalState()

  return <CompanyThemeProvider company={globalState.company}>{props.children}</CompanyThemeProvider>
}

export function CompanyThemeProvider({
  company,
  children,
}: {
  company: ICompany
  children: React.ReactNode
}) {
  const colors: Record<string, string> = {}

  if (company.primaryColor) {
    colors.primary = company.primaryColor
    colors.primaryLight = lightenDarkenColor(company.primaryColor, 0.33)
  }
  if (company.secondaryColor) {
    colors.secondary = company.secondaryColor
  }

  return (
    <CompanyThemeContext.Provider value={{ company }}>
      <ThemeProvider colors={colors}>{children}</ThemeProvider>
    </CompanyThemeContext.Provider>
  )
}
